<template>
    <v-snackbar
        v-model="show"
        color="#1976D2"
        app
        text
        top
        right
        rounded
        transition="fade-transition"
    >
        <v-icon
            color="#1976D2"
            class="material-icons-outlined mr-3"
        >
            info
        </v-icon>
        Response will be posted when online mode is enabled.
        <template v-slot:action="{ attrs }">
            <v-btn
                color="#1976D2"
                text
                v-bind="attrs"
                @click="close"
            >
                <v-icon color="#1976D2">
                    close
                </v-icon>
            </v-btn>
        </template>
    </v-snackbar>    
</template>

<script>
export default {
    props: {
        showResponseToast: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        show: {
            get() {
                return this.showResponseToast;
            },
            set() {
                this.close();
            }
        }
    },
    methods: {
        close() {
            this.$emit('close-offline-response-toast');
        }
    }
};
</script>